/**
 * A decimal typed into a text field, in the "12.8" form Decimal and the
 * server's decimal codec expect. Drivers on a Danish/Norwegian/Swedish/German
 * keyboard get a decimal comma ("12,8"), which both reject.
 */
export const normalizeDecimalInput = (value: string): string =>
  value.trim().replace(/,/g, ".");
